// extracted by mini-css-extract-plugin
export default {"nav":"navigation-module__nav__m+Y0Q","navContainer":"navigation-module__navContainer__lCpEM"};